import { ThisConnector } from '../../../../api/connector'
import { ContrastQueryParameters } from '../../../../graphql/schema/endpoint-helpers'
import { ExclusionType } from '../../../application-exclusions/exclusion-type'
import { BaseProtectRule } from '../../shared'
import { AgentLanguageKey } from '../../../agent-language'

export interface ProtectRulesApiResponse {
  rules: BaseProtectRule[]
}

interface GetProtectRulesArgs {
  organizationUuid: string
  language: AgentLanguageKey
  exclusionType: ExclusionType
}

export async function getProtectRules(
  this: ThisConnector,
  { organizationUuid, language, exclusionType }: GetProtectRulesArgs
): Promise<BaseProtectRule[]> {
  const params = new ContrastQueryParameters()
  params.append('quickFilter', language)
  params.append('exclusionType', exclusionType)

  const { rules } = await this.connector.get<ProtectRulesApiResponse>(
    `/${organizationUuid}/protection/rules?${params}`
  )

  return rules
}
